/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputProps
} from "@chakra-ui/react";
import { FieldError, FieldValues, Path, UseFormRegister } from "react-hook-form";
import { IconType } from "react-icons";
import { TextGray } from "../../Texts/TextGray";

interface Props<T extends FieldValues> extends InputProps {
  name: Path<T>;
  label?: string;
  icon?: IconType;
  error?: FieldError;
  register: UseFormRegister<T>;
}

export const InputText = <T extends FieldValues>({
  name,
  label,
  register,
  error,
  icon: IconComponent,
  ...props
}: Props<T>) => {
  return (
    <FormControl isInvalid={!!error}>
      {!!label && (
        <FormLabel htmlFor={name} fontSize="sm">
          <Flex alignItems="center">
            {IconComponent && (
              <TextGray as="span" mr="1.5">
                <IconComponent />
              </TextGray>
            )}
            {label}
          </Flex>
        </FormLabel>
      )}
      <Input
        id={name}
        _placeholder={{ color: "gray.500" }}
        {...register(name)}
        {...props}
      />
      {!!error && (
        <FormErrorMessage mt="1" fontSize="xs">
          {error.message}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};
